module.exports = __webpack_public_path__ + "static/media/homecomingcapital_featured.26a4901a.jpg";